const switchers = document.querySelectorAll<HTMLElement>("[data-language-switcher]");

switchers.forEach((switcher) => {
    const trigger = switcher.querySelector<HTMLButtonElement>("[data-language-trigger]");
    const menu = switcher.querySelector<HTMLElement>("[data-language-menu]");
    if (!trigger || !menu) return;

    trigger.addEventListener("click", (e) => {
        e.stopPropagation();
        const isOpen = !menu.classList.contains("hidden");
        if (isOpen) {
            close(trigger, menu);
        } else {
            open(trigger, menu);
        }
    });

    document.addEventListener("click", (e) => {
        if (!switcher.contains(e.target as Node)) {
            close(trigger, menu);
        }
    });

    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            close(trigger, menu);
            trigger.focus();
        }
    });
});

function open(trigger: HTMLButtonElement, menu: HTMLElement) {
    menu.querySelectorAll<HTMLAnchorElement>("a[lang]").forEach((link) => {
        const url = new URL(link.href);
        const returnPath = url.searchParams.get("returnUrl");
        if (!returnPath) return;

        const returnUrl = new URL(returnPath, window.location.origin);
        returnUrl.search = window.location.search;
        url.searchParams.set("returnUrl", returnUrl.pathname + returnUrl.search);
        link.search = url.search;
    });
    menu.classList.remove("hidden");
    menu.classList.add("flex");
    trigger.setAttribute("aria-expanded", "true");
}

function close(trigger: HTMLButtonElement, menu: HTMLElement) {
    menu.classList.add("hidden");
    menu.classList.remove("flex");
    trigger.setAttribute("aria-expanded", "false");
}
